module.exports = __webpack_public_path__ + "img/2.942f7973.png";